/* eslint-disable import/extensions */
import { ca } from './ca.js';
import { en } from './en.js';
import { gl } from './gl.js';
import { eu } from './eu.js';
import { es } from './es.js';
import { it } from './it.js';
import { fr } from './fr.js';
import { de } from './de.js';

const resources = {
	ca,
	es,
	eu,
	gl,
	de,
	fr,
	en,
	it,
};

export default resources;
